export const ABOUT_US_FIELDS = [
    "contact_email",
    "contact_phone",
    "contact_website",
    "contact_whatsapp",
    "social_facebook",
    "social_instagram",
    "social_linkedin",
    "social_tiktok",
    "social_twitter",
    "social_youtube",
];

const PRIMARY_CONTACTS = [
    {
        key: "contact_website",
        type: "website",
        href: value => normalizeUrl(value),
    },
    {
        key: "contact_phone",
        type: "phone",
        href: value => `tel:${value.replace(/\s+/g, "")}`,
    },
    {
        key: "contact_email",
        type: "email",
        href: value => `mailto:${value}`,
    },
];

const SOCIAL_CONTACTS = [
    {
        key: "contact_whatsapp",
        type: "whatsapp",
        href: value => {
            const account = value.replace(/[^\d+]/g, "").replace(/^\+/, "");
            return account ? `https://wa.me/${account}` : "";
        },
    },
    { key: "social_facebook", type: "facebook", href: normalizeUrl },
    { key: "social_instagram", type: "instagram", href: normalizeUrl },
    { key: "social_linkedin", type: "linkedin", href: normalizeUrl },
    { key: "social_tiktok", type: "tiktok", href: normalizeUrl },
    { key: "social_twitter", type: "twitter", href: normalizeUrl },
    { key: "social_youtube", type: "youtube", href: normalizeUrl },
];

export function normalizeAboutUs(aboutUs = {}) {
    return ABOUT_US_FIELDS.reduce((result, key) => {
        result[key] = normalizeText(aboutUs[key]);
        return result;
    }, {});
}

export function hasAboutUsContacts(aboutUs) {
    return getAboutUsContactItems(aboutUs).length > 0;
}

export function getAboutUsContactItems(aboutUs = {}) {
    const normalized = normalizeAboutUs(aboutUs);

    return PRIMARY_CONTACTS.concat(SOCIAL_CONTACTS)
        .map(config => {
            const value = normalized[config.key];
            if (!value) return undefined;

            const href = config.href(value);
            if (!href) return undefined;

            return {
                key: config.key,
                type: config.type,
                value,
                href,
                displayText: PRIMARY_CONTACTS.some(item => item.key === config.key) ? value : "",
                isPrimary: PRIMARY_CONTACTS.some(item => item.key === config.key),
            };
        })
        .filter(Boolean);
}

function normalizeText(value) {
    return String(value || "").trim();
}

function normalizeUrl(value) {
    const url = normalizeText(value);
    if (!url) return "";
    if (/^https?:\/\//i.test(url)) return url;
    return `https://${url}`;
}
